<template>
  <div class="param-report-page">
    <b-navbar toggleable="lg" type="dark" variant="primary" class="shadow-sm">
      <b-navbar-brand href="#" class="font-weight-bold">
        <b-icon icon="person-square" class="mr-2"></b-icon>
        {{ $route.query.desc }}
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item @click="goback()">
          <b-icon icon="x-lg" variant="light"></b-icon>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <div class="p-4">
      <div class="d-flex align-items-center mb-4 pb-2 border-bottom">
        <b-button variant="white" @click="goback()" class="mr-3 rounded-circle shadow-sm border btn-back">
          <b-icon icon="arrow-left" variant="primary"></b-icon>
        </b-button>
        <h3 class="mb-0 font-weight-bold text-dark page-title">{{ $route.query.desc }}</h3>
      </div>

      <b-row justify="center">
        <b-col lg="10" xl="8" class="mx-auto">
          <b-card no-body class="report-card shadow border-0 rounded-lg overflow-hidden">
            <div class="card-header-gradient p-3 text-white">
              <h5 class="mb-0 font-weight-bold">
                <b-icon icon="filter-square-fill" class="mr-2"></b-icon> ກຳນົດເງື່ອນໄຂການດຶງລາຍງານ
              </h5>
            </div>

            <b-card-body class="p-4 p-md-5 bg-white">
              <b-form @submit.prevent="onPreview">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="ແຕ່ວັນທີ:" label-class="label-style">
                      <b-form-datepicker v-model="fld.fromdate" locale="lao" class="custom-datepicker shadow-sm"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="ເຖິງວັນທີ:" label-class="label-style">
                      <b-form-datepicker v-model="fld.todate" locale="lao" class="custom-datepicker shadow-sm"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form-group :label="$t('users.prov_id')" label-class="label-style">
                      <b-form-select v-model="fld.prov_id" :options="provinces" required @input="getBorders" class="custom-select-styled"></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form-group :label="$t('users.border_id')" label-class="label-style">
                      <b-form-select v-model="fld.border_id" :options="borders" required class="custom-select-styled"></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <div class="mt-5 pt-3 text-center">
                  <b-button type="submit" variant="primary" class="preview-btn px-5 py-3 shadow-lg rounded-pill font-weight-bold">
                    <b-icon icon="file-earmark-bar-graph" class="mr-2"></b-icon> {{ $t('button.preview') }}
                  </b-button>
                </div>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            fld:{
                fromdate:"",
                todate:"",
                prov_id:"",
                border_id:"",
                reportname: this.$route.query.reportname,
                apiname: this.$route.query.apiname
            },
            provinces: [],
            borders: [],
        }
    },
    created() {
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/provinces/province_lao/prov_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provinces = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },

        getBorders() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/borders/border_name_lao/border_id/prov_id/" + this.fld.prov_id
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.borders = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onPreview(){
            let data = JSON.stringify(this.fld);
            // Redirect to report viewer with reportname and apiname parameters dynamic from query
            this.$router.push(`/report3/${this.fld.reportname}/${this.fld.apiname}?data=${data}`)
        }
    },
}
</script>

<style scoped>
.param-report-page {
    background-color: #f7fafc;
    min-height: 100vh;
    font-family: 'Noto Sans Lao', sans-serif;
}
.btn-back { transition: all 0.3s ease; }
.btn-back:hover { background-color: #ebf8ff; transform: translateX(-3px); }
.report-card { border-radius: 16px !important; }
.card-header-gradient { background: linear-gradient(135deg, #1B4F72 0%, #2874A6 100%); }
.label-style {
    font-weight: 700 !important;
    color: #4a5568 !important;
    font-size: 0.85rem !important;
    text-transform: uppercase;
    margin-bottom: 8px !important;
}
.custom-select-styled {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    height: 48px !important;
}
.custom-datepicker { border-radius: 8px !important; }
.preview-btn {
    min-width: 250px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    background: #1B4F72;
    border: none;
    font-size: 1.1rem;
}
.preview-btn:hover {
    background: #154360;
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(27, 79, 114, 0.3) !important;
}
</style>